export default __webpack_public_path__ + "static/media/error.596d4534.svg";